import React, { createContext, useState, useEffect, useContext } from 'react';

// 1. Create the Context
const CurrencyContext = createContext();

// 2. Create the Provider Component
const CurrencyProvider = ({ children }) => {
  const [currency, setCurrencyState] = useState(() => {
    try {
      return localStorage.getItem('currency') || 'usd';
    } catch {
      return 'usd';
    }
  });

  useEffect(() => {
    localStorage.setItem('currency', currency);
  }, [currency]);

  const setCurrency = (curr) => setCurrencyState(curr.toLowerCase());

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency }}>
      {children}
    </CurrencyContext.Provider>
  );
};

// 3. EXPORT DEFAULT THE COMPONENT
export default CurrencyProvider;

// 4. Export the hook
export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) throw new Error('useCurrency must be used within a CurrencyProvider');
  return context;
};